module.exports = __webpack_public_path__ + "static/img/gold1.970f8900.png";